import { Component, inject, Input, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { StateService } from '../../shared/services/state-service';
import { ThemeService } from '../../core/services/theme-service';
import { ButtonModule } from 'primeng/button';
import { Button } from "../../shared/components/button/button";
import { DialogBox } from "../../shared/components/dialog-box/dialog-box";
import { Avatar } from "../../shared/components/avatar/avatar";
import { DialogService } from '../../shared/services/dialog-service';
import { PackagesSearchList } from '../../pages/packages-search-list/packages-search-list';
import { fakeData } from '../../shared/fake-json/fake-data'
import { ProfileService } from '../../shared/services/profile-service';
import { UserRole } from '../../shared/model/role';
import { PageSelector } from '../page-selector/page-selector';
import { SubMenu } from '../sub-menu/sub-menu';
import { Dropdown } from '../../shared/components/dropdown/dropdown';
import { IOptions } from '../../shared/model/dropdown-options';
@Component({
  selector: 'app-header',
  imports: [ButtonModule, Avatar, PageSelector, SubMenu, Dropdown],
  templateUrl: './header.html',
  styleUrl: './header.scss',
})
export class Header implements OnInit {
  @ViewChild('sampleDialog') sampleDialog!: DialogBox;
  @ViewChild('sampleDialog1') sampleDialog1!: DialogBox;

  private router = inject(Router);
  stateService = inject(StateService);
  themeService = inject(ThemeService);
  private dialogService = inject(DialogService);
  profileService = inject(ProfileService)


  @Input() selectedTab: string | undefined = '';

  userRole: UserRole | null = null;
  userEmail: any;
  avatarLabel!: string;
  pages = [];
  profileOptions: IOptions[] = [
    { name: 'Profile', value: 'profile', id: 'profile' , icon:'profile' },
    { name: 'Logout', value: 'logout', id: 'logout', icon:'logout' }
  ];

  ngOnInit(): void {
    this.userRole = this.getRole();
    this.avatarLabel = this.userRole ? this.userRole.charAt(0).toUpperCase() : '';
    this.userEmail = this.getLoggedInUserDetails().email;
    // this.selectedtab = this.getSelectedTab()
  }

  getLoggedInUserDetails() {
    return JSON.parse(localStorage.getItem('data') || '{}');
  }

  getRole(): UserRole | null {
    const roleStr = localStorage.getItem('userRole');
    return roleStr as UserRole || null;
  }

  logout() {
    localStorage.clear();
    this.stateService.setUserLoggedIn(false);
    this.router.navigate(['/login']);
  }

  toggleSidebar() {
    this.stateService.toggleSidebar();
  }

  openDialogBox() {
    // Used to open a search dialog over mock data; the real, searchable inventory is the Packages page.
    this.router.navigate([`${localStorage.getItem('userRole')}/packages`])
  }


  onSave() {
    // this.sampleDialog1.openDailog();
  }

  OpenSample() { }

  onProfileClick() {
    // this.drawerService.open(Dashboard,'',{header:'Profile'});
    // this.dialogService.open(Dashboard)

  }

  // getSelectedTab():string {
  //   return this.stateService.getSelectedtab()
  // }

  onPageChange(event: any) {
    console.log('Selected page:', event);
    this.router.navigate([event]);
  }

  onProfileOptionSelect(option: IOptions) {
    if (option.value === 'profile') {
      this.router.navigate([`${this.userRole}/profile-detail`])
    } else if (option.value === 'logout') {
      this.logout();
    }
  }
}
